import Star from '@mui/icons-material/Star';
import StarBorder from '@mui/icons-material/StarBorder';
import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material';
import React from 'react';
import { Textfit } from 'react-textfit';
import { GalleryComment } from '../../common/models/galleryComment';

const CommentStars = (props: { comment: GalleryComment; }) => {
    return <>{[1, 2, 3, 4, 5].map((star) => {
        if (props.comment.stars >= star) {
            return <Star key={star} sx={{ color: 'yellow' }} />;
        } else {
            return <StarBorder key={star} sx={{ color: 'yellow' }} />;
        }
    })}</>;
};

export const ReviewBox = (props: BoxProps & { review: GalleryComment; }) => {
    const { review, ...restProps } = props;
    return <Box {...restProps} className='reviewBox' sx={{ ...props.sx, display: 'flex', flexDirection: 'column' }}>
        <Box className='reviewStars' sx={{ height: 25, textAlign: 'center' }}><CommentStars comment={review} /></Box>
        <Box className='reviewCommentContainer' sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Textfit style={{ padding: 2, height: 100, display: 'flex', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>{review.comment}</Textfit>
        </Box>
        <Box className='reviewAuthor' sx={{ height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{review.author}</Box>
    </Box>;
};
